export default __webpack_public_path__ + "static/media/2436.fbd3ecb4.png";